<template>
  <div id="user-form">
    <v-flex>
      <v-dialog width="500px" v-model="dialog">
        <v-card>
          <v-card-title class="headline mb-0">
            {{
            `userform.dialog.${dialogkey}.title` | t
            }}
          </v-card-title>
          <v-card-text class="text-md-left">
            {{
            `userform.dialog.${dialogkey}.text` | t
            }}
          </v-card-text>
          <v-card-actions v-if="dialogkey === 'warning'">
            <v-btn
              color="primary darken-1 white--text"
              flat="flat"
              @click="updateData"
            >{{ `userform.dialog.${dialogkey}.confirm` | t }}</v-btn>
            <v-btn
              color="primary darken-1 white--text"
              flat="flat"
              @click="noChange"
            >{{ `userform.dialog.${dialogkey}.cancel` | t }}</v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-btn
              color="primary darken-1 white--text"
              flat="flat"
              @click="noChange"
            >{{ `userform.dialog.${dialogkey}.confirm` | t }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex v-if="formload" text-md-center>
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else md12>
      <v-form v-model="valid" ref="form">
        <v-layout row wrap>
          <v-text-field
            :label="$t('userform.mail')"
            v-model="mail"
            :rules="mailRules"
            :disabled="mail_disabled"
            required
          ></v-text-field>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md5>
            <v-text-field
              :label="$t('userform.firstname')"
              v-model="firstname"
              :rules="firstnameRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md5 offset-md2>
            <v-text-field
              :label="$t('userform.lastname')"
              v-model="lastname"
              :rules="lastnameRules"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md12>
            <v-text-field :label="$t('userform.company')" v-model="company"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex :class="vatselector ? 'md4' : 'md5'" sm12>
            <v-text-field :label="$t('userform.phone')" v-model="phone" required></v-text-field>
          </v-flex>
          <v-flex :class="vatselector ? 'md4' : 'md6'" sm12 offset-md1>
            <v-text-field
              :label="$t('userform.id_card')"
              @keyup="upCard"
              v-model="id_card"
              :rules="id_cardRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex v-if="vatselector && this.company !== ''" sm12 md2 offset-md1>
            <v-btn
              :color="vatcolor"
              @click="validateVat"
              dark
              :loading="vatloading"
            >{{ `userform.vatbutton.${vatbutton}` | t }}</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md6>
            <v-text-field
              :label="$t('userform.address')"
              v-model="address"
              :rules="addressRules"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md4 offset-md2>
            <v-text-field
              :label="$t('userform.postal_code')"
              v-model="postal_code"
              :rules="postal_codeRules"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md3>
            <v-text-field :label="$t('userform.city')" v-model="city" :rules="cityRules" required></v-text-field>
          </v-flex>
          <v-flex v-if="countries.length > 0" sm12 md3 offset-md1>
            <v-autocomplete
              :label="$t('userform.country')"
              v-bind:items="this.countries"
              v-model="country"
              item-text="name"
              item-value="code"
              :rules="countryRules"
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="languages.length > 0" sm12 md3 offset-md1>
            <v-select
              :label="$t('userform.language')"
              v-bind:items="this.languages"
              v-model="language"
              item-text="name"
              item-value="code"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md12>
            <v-text-field :label="$t('userform.promo_code')" v-model="promo_code" v-mask="mask"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md12 offset-md1 class="mb-4">
            <v-btn
              v-if="shop"
              @click="confirmData"
              color="primary"
              dark
              :loading="loading"
            >{{ 'userform.button.confirm' | t }}</v-btn>
            <v-btn v-if="shop" color="primary" dark to="/shop">
              {{
              'userform.button.cancel' | t
              }}
            </v-btn>
            <v-btn
              v-else
              @click="confirmData"
              color="primary"
              dark
              :loading="loading"
            >{{ 'userform.button.change' | t }}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </div>
</template>

<script>
import capitalize from "lodash/capitalize";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: ["user", "shop", "adhoc"],
  data() {
    return {
      formload: true,
      languages: [
        { name: "Spanish", code: "es" },
        { name: "English", code: "en" }
      ],
      mask: "####-####-####",
      id: 0,
      checkinfo: false,
      dialog: false,
      dialogkey: "confirm",
      valid: true,
      loading: false,
      mail_disabled: true,
      promo_code: "",
      mail: "",
      firstname: "",
      lastname: "",
      company: "",
      id_card: "",
      phone: "",
      address: "",
      postal_code: "",
      city: "",
      country: "",
      language: "en",
      vatselector: false,
      vatloading: false,
      vatbutton: "validate",
      vatcolor: "primary",
      vat_response: "",
      taxes: 0,
      countries: []
    };
  },
  computed: {
    ...mapGetters(["getTokenHeader", "getServer", "getUserId"]),
    mailRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.mail_required"),
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$i18n.t("userform.rules.mail_valid")
      ];
    },
    cityRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.city_required"),
        v => v.length > 1 || this.$i18n.t("userform.rules.city_valid")
      ];
    },
    firstnameRules() {
      return [v => !!v || this.$i18n.t("userform.rules.firstname_required")];
    },
    lastnameRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.lastname_required"),
        v => v.length > 2 || this.$i18n.t("userform.rules.lastname_valid")
      ];
    },
    id_cardRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.id_card_required"),
        v => v.length > 5 || this.$i18n.t("userform.rules.id_card_valid")
      ];
    },
    addressRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.address_required"),
        v => v.length > 4 || this.$i18n.t("userform.rules.address_valid")
      ];
    },
    postal_codeRules() {
      return [
        v => !!v || this.$i18n.t("userform.rules.postal_code_required"),
        v => v.length > 4 || this.$i18n.t("userform.rules.postal_code_valid")
      ];
    },
    countryRules() {
      return [
        () =>
          this.country.length === 2 ||
          this.$i18n.t("userform.rules.country_required")
      ];
    }
  },
  async created() {
    if (this.user) {
      this.id = parseInt(this.user, 0);
      this.mail_disabled = false;
    } else this.id = this.getUserId;

    try {
      const resp_countries = await this.$http.get(
        `${this.getServer}/countries`
      );
      this.countries = resp_countries.data;
      const resp_user = await this.$http.get(
        `${this.getServer}/users/${this.id}`,
        this.getTokenHeader
      );
      this.mail = resp_user.data.mail;
      this.firstname = resp_user.data.firstname;
      this.lastname = resp_user.data.lastname;
      this.company = resp_user.data.company;
      this.phone = resp_user.data.phone;
      this.id_card = resp_user.data.id_card;
      this.address = resp_user.data.address;
      this.postal_code = resp_user.data.postal_code.toString();
      this.city = resp_user.data.city;
      this.country = resp_user.data.country;
      this.language = resp_user.data.language;
      this.promo_code = resp_user.data.promo_code;
      this.checkTaxes();
      if (resp_user.data.vat_valid === 1) {
        this.vatcolor = "success";
        this.vatbutton = "ok";
      }
      this.formload = false;
    } catch (error) {
      this.dialogkey = "problems";
      this.dialog = true;
      this.rmKey();
    }
  },
  watch: {
    country() {
      this.checkTaxes();
    }
  },
  methods: {
    ...mapActions(["rmKey"]),
    async validateVat() {
      this.vatloading = true;
      const company = { number: this.id_card, country: this.country };
      try {
        const res_shop = await this.$http.post(
          `${this.getServer}/shop/vat`,
          company,
          this.getTokenHeader
        );
        this.vatloading = false;
        if (res_shop.data.is_valid) {
          this.vatcolor = "success";
          this.vatbutton = "ok";
          this.vat_response = JSON.stringify(res_shop.data);
        } else {
          this.vatcolor = "error";
          this.vatbutton = "ko";
          this.vat_response = "";
        }
      } catch (error) {
        this.vatloading = false;
      }
    },
    checkTaxes() {
      const country = this.countries.find(x => x.code === this.country);
      if (country && country.taxes && country.taxes !== 0) {
        if (country.code === "es") {
          this.taxes = country.taxes;
          this.vatselector = false;
        } else {
          this.taxes = country.taxes;
          this.vatselector = true;
        }
      } else {
        this.vatselector = false;
        this.taxes = 0;
      }
    },
    upCard() {
      this.id_card = this.id_card.toUpperCase();
      this.vatcolor = "primary";
      this.vatbutton = "validate";
    },
    noChange() {
      this.dialog = false;
      this.loading = false;
    },
    confirmData() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.dialogkey = "warning";
        this.dialog = true;
      } else {
        this.loading = false;
        this.dialogkey = "invaliddata";
        this.dialog = true;
      }
    },
    async updateData() {
      this.dialog = false;
      const userdata = {
        mail: this.mail.toLowerCase(),
        firstname: capitalize(this.firstname),
        lastname: capitalize(this.lastname),
        company: this.company,
        id_card: this.id_card,
        phone: this.phone,
        address: this.address,
        postal_code: this.postal_code.toString(),
        city: capitalize(this.city),
        country: this.country,
        language: this.language,
        promo_code: this.promo_code
      };

      if (this.vatbutton === "ok") {
        userdata.vat_valid = true;
        if (this.vat_response !== "") userdata.vat_response = this.vat_response;
      } else {
        userdata.vat_valid = false;
        userdata.vat_response = "";
      }

      await this.$http.put(
        `${this.getServer}/users/${this.id}`,
        userdata,
        this.getTokenHeader
      );
      this.loading = false;
      localStorage.setItem("language", this.language);
      this.$i18n.locale = this.language;
      if (this.shop === true) {
        if (this.adhoc) this.$router.push({ path: "/shop/ondemand/cart" });
        else this.$router.push({ path: "/shop/cart" });
      } else {
        this.dialogkey = "confirm";
        this.dialog = true;
      }
    }
  }
};
</script>
